import { decode } from 'js-base64';
export class Token {
    constructor(jwt) {
        this.jwt = jwt;
        this.body = parseToken(jwt);
    }
    get userId() {
        return this.body.user.id;
    }
}
export function parseToken(jwt) {
    const ret = JSON.parse(decode(jwt.split('.')[1]));
    return Object.assign(Object.assign({}, ret), { iat: new Date(ret.iat * 1000), exp: new Date(ret.exp * 1000) });
}
//# sourceMappingURL=token.js.map